import { render, staticRenderFns } from "./GateSetup.vue?vue&type=template&id=13fcd48d"
import script from "./GateSetup.vue?vue&type=script&lang=ts"
export * from "./GateSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports